export const telegramImageModalName = 'telegram-image';
